import React from 'react';
import { getProgress } from '../ContentItemCarousel/helpers';
import { ContentItemGridBlock, StyledContentItemGrid } from './ContentItemGrid.styles';
import { InView } from 'react-intersection-observer';

const ContentItemGrid = (props) => {
    const {
        items,
        id,
        editModeActivated,
        location,
        presentation,
        preferredAccessVersion,
        onItemClick,
        continueWatchingIsActive,
        continueWatchingItems,
        isInSweden,
        shouldUseIntersectionObserver = false,
        autoPlay = false,
    } = props;

    return (
        <StyledContentItemGrid data-rt="content-item-grid">
            {items.map((content, i) => {
                const contentItemIndex = i + 1;

                const gridItemProps = {
                    index: i,
                    content: content,
                    slidableListId: id,
                    preferThumbnail: false,
                    editModeActivated: editModeActivated,
                    location: location,
                    presentation: presentation,
                    preferredAccessVersion: preferredAccessVersion,
                    progress: getProgress(content, continueWatchingIsActive, continueWatchingItems),
                    onClick: onItemClick,
                    itemPosition: contentItemIndex,
                    isInSweden: isInSweden,
                    autoPlay: autoPlay,
                };

                if (shouldUseIntersectionObserver) {
                    return (
                        <InView rootMargin="200px 0px" triggerOnce key={content.id}>
                            {({ inView, ref, entry }) => (
                                <ContentItemGridBlock {...gridItemProps} forwardedRef={ref} inView={inView} />
                            )}
                        </InView>
                    );
                }

                return <ContentItemGridBlock key={content.id} {...gridItemProps} inView />;
            })}
        </StyledContentItemGrid>
    );
};

export default ContentItemGrid;
